import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { useUser } from '~/composables/_next/useUser';
import { getProductPrice } from '~/utils/ProductPrice';
import { useCart } from '@/composables/useCart';
import useAddToCart from '@/composables/useAddToCart';
import AzImg from '~/components/Atoms/AzImg.vue';
import AddToCartButton from '~/components/Layout/Cart/AddToCart/AddToCartButton.vue';
import { getIsNewProduct } from '~/helpers/productCardMethods';
import useRightPath from '~/composables/useRightPath';
import { useProduct } from '~/composables/_next/useProduct';
import { centimesToEuros, gtmValue } from '~/helpers/gtm';
import { klaviyoClientPushEvent } from '~/helpers/tracking/klaviyo';
import { useWait } from '~/composables/_next/useWait';
import AzModal from '~/components/_next/molecules/AzModal.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzPanelAddedToCartProductList from '~/components/_next/molecules/AzPanelAddedToCartProductList.vue';
import AzPanelAddToCartAttributeChoice from '~/components/_next/molecules/AzPanelAddToCartAttributeChoice.vue';
import AzAttributeChoiceSelect from '~/components/_next/molecules/AzAttributeChoiceSelect.vue';
import { filterProducts } from '~/utils/commercetools/products';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { useLocalization } from '~/composables/_next/useLocalization';
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalAddToCartOrganism',
  emits: ['close', 'openCart'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var _useDynamicYield = useDynamicYield(),
      trackDynamicYieldEvent = _useDynamicYield.trackDynamicYieldEvent,
      formatDYprice = _useDynamicYield.formatDYprice;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $trackers = _useNuxt2App.$trackers;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var route = useRoute();
    var _useUiState = useUiState(),
      _closeAddToCartModal = _useUiState.closeAddToCartModal,
      addToCartModalProduct = _useUiState.addToCartModalProduct,
      openBackInStockModal = _useUiState.openBackInStockModal,
      _toggleCartSidebar = _useUiState.toggleCartSidebar;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    var _useCart = useCart(),
      addItemById = _useCart.addItemById,
      cart = _useCart.cart;
    var _useUser = useUser(),
      user = _useUser.user,
      isAuthenticated = _useUser.isAuthenticated;
    var _useProduct = useProduct('addToCartModal'),
      products = _useProduct.products,
      search = _useProduct.search,
      productLoading = _useProduct.loading;
    var _useAddToCart = useAddToCart(),
      normalizeVariants = _useAddToCart.normalizeVariants,
      findVariantByAttrib = _useAddToCart.findVariantByAttrib;
    var _useWait = useWait(),
      startWaiter = _useWait.startWaiter,
      endWaiter = _useWait.endWaiter,
      isWaiting = _useWait.isWaiting;
    var modalRef = ref(null);
    var modalDisplay = ref('capacity');
    var selectedVariant = ref({});
    var currentVariant = ref(null);
    var showVariantSelector = ref(false);
    var imageUrl = computed(function () {
      var _addToCartModalProduc, _addToCartModalProduc2, _addToCartModalProduc3, _addToCartModalProduc4;
      return (_addToCartModalProduc = (_addToCartModalProduc2 = addToCartModalProduct.value) === null || _addToCartModalProduc2 === void 0 ? void 0 : (_addToCartModalProduc3 = _addToCartModalProduc2.images) === null || _addToCartModalProduc3 === void 0 ? void 0 : (_addToCartModalProduc4 = _addToCartModalProduc3[0]) === null || _addToCartModalProduc4 === void 0 ? void 0 : _addToCartModalProduc4.url) !== null && _addToCartModalProduc !== void 0 ? _addToCartModalProduc : '';
    });
    var priceRegular = computed(function () {
      return getProductPrice(currentVariant.value || masterProduct.value).regular;
    });
    var priceSpecial = computed(function () {
      return getProductPrice(currentVariant.value || masterProduct.value).special;
    });
    var masterProduct = computed(function () {
      var _filterProducts = filterProducts(products.value, {
          attributes: selectedVariant.value
        }),
        _filterProducts2 = _slicedToArray(_filterProducts, 1),
        product = _filterProducts2[0];
      return product;
    });
    var normalizedVariants = computed(function () {
      return normalizeVariants(products.value);
    });
    var isCurrentVariantUnavailable = computed(function () {
      return currentVariant.value && !currentVariant.value.isSellable;
    });
    watch(addToCartModalProduct, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(newProduct, oldProduct) {
        var _newProduct$_slug;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!newProduct) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return search({
                slug: (_newProduct$_slug = newProduct._slug) !== null && _newProduct$_slug !== void 0 ? _newProduct$_slug : newProduct.slug
              });
            case 3:
              currentVariant.value = normalizedVariants.value.find(function (variant) {
                return String(variant.id) === newProduct.id;
              }) || normalizedVariants.value[0];
              if (normalizedVariants.value.length > 1) {
                showVariantSelector.value = true;
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());

    /**
     * Sets the variant.
     *
     * @param      {Object}  attribs  The attributes
     */
    function setVariant(attribs) {
      currentVariant.value = findVariantByAttrib(normalizedVariants.value, _objectSpread(_objectSpread({}, currentVariant.value.attributes), attribs)) || currentVariant.value;
    }
    /**
     * Updates the product's __position based on the given SKU and returns the updated product object.
     * @param {string} sku - The SKU to locate in the variantIDs array.
     * @returns {Record<string, any>} - The updated product object.
     */
    function updateProductPositionBySku(sku) {
      var _addToCartModalProduc5, _product$variantIDs;
      var product = (_addToCartModalProduc5 = addToCartModalProduct.value) !== null && _addToCartModalProduc5 !== void 0 ? _addToCartModalProduc5 : {};
      var variantIDs = (_product$variantIDs = product.variantIDs) !== null && _product$variantIDs !== void 0 ? _product$variantIDs : [];
      var index = variantIDs.indexOf(sku);
      if (index !== -1) {
        product.__position = index + 1;
      } else {
        console.warn("SKU \"".concat(sku, "\" not found in variantIDs."));
        return product;
      }
      return product;
    }
    /**
     * Search the correct variant and sends it to the `back in stock` modal
     */
    function switchToBackInStockModal() {
      var _currentVariant$value;
      var product = addToCartModalProduct.value.objectID ? updateProductPositionBySku((_currentVariant$value = currentVariant.value) === null || _currentVariant$value === void 0 ? void 0 : _currentVariant$value.sku) : addToCartModalProduct.value.variants.find(function (p) {
        var _currentVariant$value2;
        return p.sku === ((_currentVariant$value2 = currentVariant.value) === null || _currentVariant$value2 === void 0 ? void 0 : _currentVariant$value2.sku);
      });
      openBackInStockModal(product);
      closeAddToCartModal();
    }

    /**
     * Adds the current variant to the cart
     * and sends various analytics.
     * Displays a success panel on mobile and the cart on desktop.
     */
    function addCurrentVariantToCart() {
      return _addCurrentVariantToCart.apply(this, arguments);
    }
    /**
     * Sets the modal display.
     *
     * @param      {('confirm'|'equipments'|'ingredients')}  [display='ingredients']  The display
     */
    function _addCurrentVariantToCart() {
      _addCurrentVariantToCart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _addToCartModalProduc6, _addToCartModalProduc7;
        var currentIndex, _addToCartModalProduc8, _currentVariant$value3, _currentVariant$value4, _currentVariant$value5, _currentVariant$value6, _currentVariant$value7, _currentVariant$value8, _currentVariant$value9, _currentVariant$value0, _currentVariant$value1, _currentVariant$value10, _currentVariant$value11, _currentVariant$value12, _currentVariant$value13, _currentVariant$value14, _currentVariant$value15, _currentVariant$value16, _currentVariant$value17, _currentVariant$value18, _currentVariant$value19, _currentVariant$value20, _currentVariant$value21, _currentVariant$value22, _currentVariant$value23, _currentVariant$value24, _currentVariant$value25, _currentVariant$value26, _cart$value, _currentVariant$value27, _user$value, _addToCartModalProduc9, price, discountPrice, pageUrl, customerEmail, _currentVariant$value28, _currentVariant$value29, _currentVariant$value30, _currentVariant$value31, _addToCartModalProduc0, _currentVariant$value32, _currentVariant$value33, AddedProperties;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              currentIndex = (_addToCartModalProduc6 = (_addToCartModalProduc7 = addToCartModalProduct.value) === null || _addToCartModalProduc7 === void 0 ? void 0 : _addToCartModalProduc7.productIndex) !== null && _addToCartModalProduc6 !== void 0 ? _addToCartModalProduc6 : null;
              if (!(currentVariant.value && currentVariant.value.isSellable)) {
                _context2.next = 22;
                break;
              }
              startWaiter("add-to-cart-modal-".concat((_addToCartModalProduc8 = addToCartModalProduct.value) === null || _addToCartModalProduc8 === void 0 ? void 0 : _addToCartModalProduc8._id));
              _context2.prev = 3;
              _context2.next = 6;
              return addItemById({
                product: currentVariant.value,
                quantity: 1,
                showConfirmation: !isMobile.value,
                customQuery: {
                  updateCart: 'updateCartCustom'
                }
              });
            case 6:
              _context2.next = 11;
              break;
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](3);
              console.error('Failed to add item to cart', _context2.t0);
            case 11:
              _context2.prev = 11;
              endWaiter("add-to-cart-modal-".concat((_addToCartModalProduc9 = addToCartModalProduct.value) === null || _addToCartModalProduc9 === void 0 ? void 0 : _addToCartModalProduc9._id));
              return _context2.finish(11);
            case 14:
              if (isMobile.value) {
                setModalDisplay('confirm');
              } else {
                closeAddToCartModal();
              }
              price = centimesToEuros((_currentVariant$value3 = currentVariant.value) === null || _currentVariant$value3 === void 0 ? void 0 : (_currentVariant$value4 = _currentVariant$value3.price) === null || _currentVariant$value4 === void 0 ? void 0 : (_currentVariant$value5 = _currentVariant$value4.value) === null || _currentVariant$value5 === void 0 ? void 0 : _currentVariant$value5.centAmount);
              discountPrice = (_currentVariant$value6 = currentVariant.value) !== null && _currentVariant$value6 !== void 0 && (_currentVariant$value7 = _currentVariant$value6.price) !== null && _currentVariant$value7 !== void 0 && (_currentVariant$value8 = _currentVariant$value7.discounted) !== null && _currentVariant$value8 !== void 0 && (_currentVariant$value9 = _currentVariant$value8.value) !== null && _currentVariant$value9 !== void 0 && _currentVariant$value9.centAmount ? centimesToEuros((_currentVariant$value0 = currentVariant.value) === null || _currentVariant$value0 === void 0 ? void 0 : (_currentVariant$value1 = _currentVariant$value0.price) === null || _currentVariant$value1 === void 0 ? void 0 : (_currentVariant$value10 = _currentVariant$value1.discounted) === null || _currentVariant$value10 === void 0 ? void 0 : (_currentVariant$value11 = _currentVariant$value10.value) === null || _currentVariant$value11 === void 0 ? void 0 : _currentVariant$value11.centAmount) : undefined;
              pageUrl = route.fullPath;
              trackDynamicYieldEvent({
                name: 'Add to Cart',
                properties: {
                  dyType: 'add-to-cart-v1',
                  value: formatDYprice(price, discountPrice),
                  currency: 'EUR',
                  productId: (_currentVariant$value12 = currentVariant.value) === null || _currentVariant$value12 === void 0 ? void 0 : _currentVariant$value12.sku,
                  quantity: 1,
                  cart: [{
                    productId: (_currentVariant$value13 = currentVariant.value) === null || _currentVariant$value13 === void 0 ? void 0 : _currentVariant$value13.sku,
                    quantity: 1,
                    itemPrice: formatDYprice(price, discountPrice)
                  }]
                }
              });
              $trackers.gtm.trackAddToCart({
                title: (_currentVariant$value14 = currentVariant.value) === null || _currentVariant$value14 === void 0 ? void 0 : _currentVariant$value14.name,
                sku: (_currentVariant$value15 = currentVariant.value) === null || _currentVariant$value15 === void 0 ? void 0 : _currentVariant$value15.sku,
                priceRegular: (_currentVariant$value16 = currentVariant.value) === null || _currentVariant$value16 === void 0 ? void 0 : (_currentVariant$value17 = _currentVariant$value16.price) === null || _currentVariant$value17 === void 0 ? void 0 : (_currentVariant$value18 = _currentVariant$value17.value) === null || _currentVariant$value18 === void 0 ? void 0 : _currentVariant$value18.centAmount,
                priceSpecial: (_currentVariant$value19 = currentVariant.value) === null || _currentVariant$value19 === void 0 ? void 0 : (_currentVariant$value20 = _currentVariant$value19.price) === null || _currentVariant$value20 === void 0 ? void 0 : (_currentVariant$value21 = _currentVariant$value20.discounted) === null || _currentVariant$value21 === void 0 ? void 0 : (_currentVariant$value22 = _currentVariant$value21.value) === null || _currentVariant$value22 === void 0 ? void 0 : _currentVariant$value22.centAmount,
                quantity: 1,
                isNewProduct: getIsNewProduct(currentVariant.value),
                index: currentIndex ? Number(currentIndex) + 1 : '',
                isMaster: (_currentVariant$value23 = currentVariant.value) === null || _currentVariant$value23 === void 0 ? void 0 : _currentVariant$value23._master,
                currency: (_currentVariant$value24 = currentVariant.value) === null || _currentVariant$value24 === void 0 ? void 0 : (_currentVariant$value25 = _currentVariant$value24.price) === null || _currentVariant$value25 === void 0 ? void 0 : (_currentVariant$value26 = _currentVariant$value25.value) === null || _currentVariant$value26 === void 0 ? void 0 : _currentVariant$value26.currencyCode,
                cartId: ((_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : _cart$value.id) || '',
                ctId: (_currentVariant$value27 = currentVariant.value) === null || _currentVariant$value27 === void 0 ? void 0 : _currentVariant$value27._id,
                pageUrl: pageUrl,
                itemLocation: 'product_card',
                extraFields: {
                  item_category: false,
                  is_attraqt_upsell_product: false
                }
              });
              customerEmail = isAuthenticated.value ? (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.email : '';
              if (customerEmail) {
                AddedProperties = {
                  AddedToCartValue: gtmValue(price, discountPrice),
                  AddedItemCategories: 'product',
                  AddedItemCurrency: (_currentVariant$value28 = currentVariant.value) === null || _currentVariant$value28 === void 0 ? void 0 : (_currentVariant$value29 = _currentVariant$value28.price) === null || _currentVariant$value29 === void 0 ? void 0 : (_currentVariant$value30 = _currentVariant$value29.value) === null || _currentVariant$value30 === void 0 ? void 0 : _currentVariant$value30.currencyCode,
                  AddedItemImageURL: (_currentVariant$value31 = currentVariant.value) === null || _currentVariant$value31 === void 0 ? void 0 : _currentVariant$value31.mainImage,
                  AddedItemPrice: price,
                  AddedItemPriceDiscount: discountPrice || '',
                  AddedItemProductID: ((_addToCartModalProduc0 = addToCartModalProduct.value) === null || _addToCartModalProduc0 === void 0 ? void 0 : _addToCartModalProduc0._id) || '',
                  AddedItemProductName: (_currentVariant$value32 = currentVariant.value) === null || _currentVariant$value32 === void 0 ? void 0 : _currentVariant$value32.name,
                  AddedItemProductSKU: (_currentVariant$value33 = currentVariant.value) === null || _currentVariant$value33 === void 0 ? void 0 : _currentVariant$value33.sku,
                  AddedItemProductUrl: app.localePath(getProductPath(addToCartModalProduct.value)),
                  AddedItemQuantity: 1,
                  AddedItemURL: pageUrl
                };
                klaviyoClientPushEvent(customerEmail, locale, AddedProperties, 'Added to cart');
              }
            case 22:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 8, 11, 14]]);
      }));
      return _addCurrentVariantToCart.apply(this, arguments);
    }
    function setModalDisplay() {
      var display = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'capacity';
      modalDisplay.value = display;
    }

    /**
     * Closes the add to cart modal
     * and resets its state.
     */
    function closeAddToCartModal() {
      setModalDisplay('capacity');
      _closeAddToCartModal();
    }

    /**
     * Toggles the cart sidebar and closes the addToCart modal
     */
    function toggleCartSidebar() {
      _toggleCartSidebar();
      closeAddToCartModal();
    }
    expose({
      modalRef: modalRef
    });
    return {
      __sfc: true,
      emit: emit,
      trackDynamicYieldEvent: trackDynamicYieldEvent,
      formatDYprice: formatDYprice,
      app: app,
      $trackers: $trackers,
      locale: locale,
      route: route,
      _closeAddToCartModal: _closeAddToCartModal,
      addToCartModalProduct: addToCartModalProduct,
      openBackInStockModal: openBackInStockModal,
      _toggleCartSidebar: _toggleCartSidebar,
      isMobile: isMobile,
      getProductPath: getProductPath,
      addItemById: addItemById,
      cart: cart,
      user: user,
      isAuthenticated: isAuthenticated,
      products: products,
      search: search,
      productLoading: productLoading,
      normalizeVariants: normalizeVariants,
      findVariantByAttrib: findVariantByAttrib,
      startWaiter: startWaiter,
      endWaiter: endWaiter,
      isWaiting: isWaiting,
      modalRef: modalRef,
      modalDisplay: modalDisplay,
      selectedVariant: selectedVariant,
      currentVariant: currentVariant,
      showVariantSelector: showVariantSelector,
      imageUrl: imageUrl,
      priceRegular: priceRegular,
      priceSpecial: priceSpecial,
      masterProduct: masterProduct,
      normalizedVariants: normalizedVariants,
      isCurrentVariantUnavailable: isCurrentVariantUnavailable,
      setVariant: setVariant,
      updateProductPositionBySku: updateProductPositionBySku,
      switchToBackInStockModal: switchToBackInStockModal,
      addCurrentVariantToCart: addCurrentVariantToCart,
      setModalDisplay: setModalDisplay,
      closeAddToCartModal: closeAddToCartModal,
      toggleCartSidebar: toggleCartSidebar,
      AzImg: AzImg,
      AddToCartButton: AddToCartButton,
      AzModal: AzModal,
      AzButton: AzButton,
      AzIcon: AzIcon,
      AzPanelAddedToCartProductList: AzPanelAddedToCartProductList,
      AzPanelAddToCartAttributeChoice: AzPanelAddToCartAttributeChoice,
      AzAttributeChoiceSelect: AzAttributeChoiceSelect
    };
  }
});